import {
  DISPLAYED_COLUMNS,
  DISPLAYED_FILTERS,
  getColumnDetails,
  MdrCompaniesGridWebComponentSchema,
  SsoAvailabilityResponse,
} from '../types';
import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, ViewType } from '../../../grid/gridView/types';

export class MdrCompaniesGridDataProvider extends BaseWebComponentDataProvider {
  public async getDataForView(): Promise<MdrCompaniesGridWebComponentSchema> {
    const view = {
      id: 'mdr-companies-grid',
      name: 'Default MDR companies grid',
      type: ViewType.DEFAULT,
      filters: DISPLAYED_FILTERS,
      displayedColumns: DISPLAYED_COLUMNS,
      pageSize: DEFAULT_PAGE_SIZE,
      pageNumber: DEFAULT_PAGE_NUMBER,
      compactView: false,
    };

    const ssoAvailability = await this.getSsoAvailability();

    return {
      view,
      columns: getColumnDetails(),
      ssoIsAvailable: ssoAvailability,
    };
  }

  public async getSsoAvailability(): Promise<boolean> {
    try {
      return (await this.dependencies.api.clients.Company.checkSsoAvailability().toPromise()).isAvailable;
    } catch (e) {
      return false;
    }
  }
}
